import { render } from "./allCustomerStory.vue?vue&type=template&id=0f31aafe"
import script from "./allCustomerStory.vue?vue&type=script&lang=js"
export * from "./allCustomerStory.vue?vue&type=script&lang=js"

import "./allCustomerStory.vue?vue&type=style&index=0&id=0f31aafe&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__